import { Injectable } from '@angular/core';
import { InstrumentSearchFacadeService, InstrumentSearchParams } from '@zero/search/domain';

@Injectable({
  providedIn: 'root',
})
export class InstrumentSearchApiService {
  constructor(private searchFacade: InstrumentSearchFacadeService) {}

  public searchByQuery(query?: string, params?: InstrumentSearchParams) {
    return this.searchFacade.searchByQuery(query, params);
  }

  public searchByIsin(isin?: string, params?: InstrumentSearchParams) {
    return this.searchFacade.searchByIsin(isin, params);
  }

  public getAssetByIsin(isin: string) {
    return this.searchFacade.getAssetByIsin(isin);
  }
}
